const styles = theme => ({
    nextButton: {
        textTransform: 'none',
        fontWeight: 'bold',
        whiteSpace: 'nowrap',
        paddingLeft: 40,
        paddingRight: 40,
        height: 50
    },
    root: {
        overflow: 'hidden',
        padding: 0,
        margin: 0
    },
    wrapper: {
        height: '100%',
        overflow: 'hidden'
    },
    sidebar: {
        width: '40%',
        background: theme.palette.blue[50],
        height: '100%',
        padding: '135px 80px 90px 70px',
        '& b': {
            fontWeight: 800
        },
        '& a': {
            color: theme.palette.blue[500],
            fontWeight: 600,
            textDecoration: 'underline'
        },
        color: theme.palette.grey[900],
        '& .title': {
            fontSize: 34,
            fontWeight: 600,
            [theme.breakpoints.down('xl')]: {
                fontSize: 22
            },
            '& .description': {
                fontSize: 20,
                fontWeight: 400,
                '& span': {
                    fontWeight: 600
                }
            },
            '& .generateWarning': {
                color: theme.palette.yellow[900],
                textAlign: 'left',
                fontSize: 27,
                fontWeight: 400,
                marginTop: 30,
                [theme.breakpoints.down('xl')]: {
                    fontSize: 18
                },
                '& button': {
                    fontWeight: 600,
                    textDecoration: 'underline'
                }
            }
        },
        '& .steps': {
            fontSize: 27,
            [theme.breakpoints.down('xl')]: {
                fontSize: 18
            }
        },
        [theme.breakpoints.down('xl')]: {
            width: '30%',
            padding: '80px 40px 40px 30px'
        }
    },
    content: {
        padding: '100px',
        flex: 1,
        backgroundColor: theme.palette.grey[100],
        overflowY: 'auto',
        [theme.breakpoints.down('xl')]: {
            padding: 50
        }
    },
    invisible: {
        opacity: 0,
        position: 'absolute',
        left: -9999
    },
    title: {
        fontSize: 30,
        fontWeight: 700,
        color: theme.palette.grey[900],
        marginBottom: 25,
        [theme.breakpoints.down('xl')]: {
            fontSize: 20,
            marginBottom: 12
        }
    },
    uploadArea: {
        backgroundColor: 'white',
        position: 'relative',
        border: `2px solid ${theme.palette.grey[300]}`,
        width: '100%',
        height: 270,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        '& i': {
            cursor: 'pointer',
            color: '#545556'
        },
        '&.disabled': {
            backgroundColor: theme.palette.grey[100],
            '& i': {
                opacity: 0.6,
                cursor: 'default'
            }
        },
        '&:not(.disabled) i:hover': {
            opacity: 0.8
        },
        '& .helperText': {
            fontSize: 14,
            fontWeight: 400,
            color: theme.palette.grey[500],
            '&.error': {
                color: theme.palette.red[600]
            }
        },
        [theme.breakpoints.down('xl')]: {
            height: 180
        },
        '@media (max-height: 800px)': {
            height: 130,
            '& i': {
                fontSize: 32
            }
        }
    },
    baseButton: {
        color: theme.palette.blue[800],
        fontSize: 14,
        fontWeight: 400,
        textAlign: 'center',
        display: 'block',
        cursor: 'pointer',
        margin: '0 auto'
    },
    uploadButton: {
        color: theme.palette.blue[800],
        fontSize: 14,
        fontWeight: 400,
        textAlign: 'center',
        display: 'block',
        margin: '0 auto'
    },
    divider: {
        fontSize: 37,
        fontWeight: 600,
        color: theme.palette.grey[900],
        margin: '30px 0',
        [theme.breakpoints.down('xl')]: {
            fontSize: 24,
            margin: '10px 0'
        }
    },
    textInput: {
        '& .Mui-disabled + fieldset': {
            backgroundColor: theme.palette.grey[100]
        }
    },
    counterClass: {
        color: theme.palette.grey[600],
        fontSize: 10,
        fontWeight: 400,
        textAlign: 'left',
        marginLeft: -13
    },
    helperInputClass: {
        '& .helperText': {
            display: 'none'
        }
    },
    actions: {
        padding: '20px 70px',
        background: 'white',
        [theme.breakpoints.down('md')]: {
            padding: '30px'
        },
        '& button': {
            height: 40
        }
    },
    loading: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 700,
        fontSize: 36,
        '& .text': {
            marginTop: 40,
            color: theme.palette.grey[900]
        },
        '& .percent': {
            color: theme.palette.blue[500],
            marginTop: 18
        }
    },
    readyWrapper: {
        background: theme.palette.blue[50],
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflowY: 'auto',
        padding: '50px 0',
        '& .title': {
            fontSize: 35,
            fontWeight: 800,
            color: theme.palette.grey[900]
        },
        '& .assessmentName': {
            fontSize: 30,
            fontWeight: 700,
            color: theme.palette.grey[900],
            textAlign: 'center',
            maxWidth: ' 80%'
        },
        '& .table': {
            maxWidth: 950,
            fontWeight: 700,
            color: theme.palette.grey[900],
            '& .tableHeader': {
                display: 'flex',
                alignItems: 'center',
                background: theme.palette.grey[200],
                marginTop: 50,
                padding: '16px 38px',
                fontSize: 16,
                borderTopLeftRadius: 8,
                borderTopRightRadius: 8,
                gap: 290,
                '& img': {
                    marginTop: -5,
                    marginRight: 10
                }
            },
            '& .tableBody': {
                fontSize: 14,
                lineHeight: '26px',
                display: 'flex',
                background: theme.palette.grey[50],
                width: '100%',
                padding: '30px 45px',
                borderBottomLeftRadius: 8,
                borderBottomRightRadius: 8,
                '& .skills': {
                    width: '60%',
                    borderRight: `1px solid ${theme.palette.grey[300]}`,
                    paddingRight: 30,
                    '& ol': {
                        paddingLeft: 15
                    }
                },
                '& .questionTypes': {
                    paddingLeft: 30
                }
            },
            '& span': {
                fontWeight: 400
            }
        },
        '& .footerHelpText': {
            width: 175,
            fontSize: 14,
            fontWeight: 400,
            textAlign: 'center',
            margin: '34px 0 6px',
            lineHeight: '24px'
        }
    },
    inviteButton: {
        marginTop: 48
    },
    footerButton: {
        width: 245
    },
    startAgainButton: {
        margin: '0 auto'
    },
    fileLoadingOverlay: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.4)',
        zIndex: 2
    },
    emodji: {
        fontSize: 26
    },
    assessmentsButton: {
        fontSize: 30,
        fontWeight: 600,
        color: theme.palette.blue[500],
        marginBottom: 25,
        marginLeft: -8,
        [theme.breakpoints.down('xl')]: {
            fontSize: 20,
            marginBottom: 12
        }
    },
    startOverButton: {
        width: 120
    },
    exploerLibraryButton: {
        width: 400
    }
});

export default styles;
